module.exports = __webpack_public_path__ + "static/media/no-profile.4b0bd202.png";